import { KPIPhongBanPagingResponse, KPIPhongBanResponse } from '@app/models/kpi/KPIPhongBan';
import { Button, Col, DatePicker, DatePickerProps, Form, Input, Row, Space, Table  } from 'antd';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { chucVu } from '../../constants';;
import styled from 'styled-components';
import React from 'react';
import { layDanhMucNhanVien } from '../../services/danhmuc';
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';

const PrintPageToHere = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      width: 210mm;
      background-color: white;
      font-family: "Times New Roman", Times, serif;
    }

    /* Thiết lập phân trang */
    div {
      page-break-inside: always;
    }
    
    /* Định dạng các trang in */
    @page {
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 3cm;
      margin-right: 2cm;
    }
  }
`;
const InBaoCaoKPIPhongBan = ({ idDonVi, tuKhoa, thangNam, listData, noiDung }: { idDonVi: number, tuKhoa: string, thangNam: string, listData?: KPIPhongBanPagingResponse, noiDung: string }) => {
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const user = useSelector((state: any) => state.auth.currentUser);
    const [chanhVP, setChanhVP] = useState<NhanVienResponse>();
    const [giamDoc, setGiamDoc] = useState<NhanVienResponse>();
    const layChanhVanPhong = async () => {
        let rs = await layDanhMucNhanVien();
        setChanhVP(rs.filter((item: any) => item.idChucVu == chucVu.chanhVanPhong)[0])
        setGiamDoc(rs.filter((item: any) => item.idChucVu == chucVu.giamDoc)[0])
    }

    const checkInThangNam = thangNam.split(' ')[0];
    const [ngay, thang, nam] = checkInThangNam.split('/');

    function getTodayDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Tháng trong JavaScript tính từ 0 đến 11, nên cần cộng 1
        const year = today.getFullYear();

        const todayDate = day + '/' + month + '/' + year;
        return todayDate;
    }
    const todayDate = getTodayDate();
    const [ngaytoday, thangtoday, namtoday] = todayDate.split('/');

    const groupedData: { [key: string]: any[] } = {};
    listData?.data.forEach((item) => {
        if (!groupedData[item.tenDonVi]) {
            groupedData[item.tenDonVi] = [];
        }
        groupedData[item.tenDonVi].push(item);
    });

    const layXepLoai = (diem: any) => {
        if (diem === undefined || diem === null) {
            return ""; // Trường hợp dữ liệu không có, trả về giá trị trống
        }
        if (diem > 100) {
            return "A+";
        } else if (diem >= 96 && diem <= 100) {
            return "A";
        } else if (diem >= 85 && diem <= 95) {
            return "B";
        } else if (diem < 85) {
            return "C";
        } else {
            return "";
        }
    };
    type TableLayout = "auto" | "fixed";

    const rowFormat: React.CSSProperties = {
        textAlign: "center",
        tableLayout: "auto" as TableLayout,
        borderCollapse: "collapse",
        border: "1px solid   ",
        fontFamily: 'Times New Roman'
    };

    const rowTableFormat: React.CSSProperties = {
        textAlign: "center",
        width: "30px",
        borderCollapse: "collapse",
        border: "1px solid   ",
        fontFamily: 'Times New Roman'
    };

    const getFormattedDate = () => {
        const currentDate = new Date();
        const ngay = currentDate.getDate();
        const thang = currentDate.getMonth() + 1; // Tháng bắt đầu từ 0, nên cộng thêm 1
        const nam = currentDate.getFullYear();
    }

    // Sử dụng hàm để lấy ngày, tháng, năm và điền vào câu
    const formattedDate = getFormattedDate();

    useEffect(() => {
        if (reloadPage) {
            layChanhVanPhong()
       }
    }, [reloadPage]);

    return (
        <PrintPageToHere>
            <Row gutter={8}  >
                <Col span={6} className="left-col" style={{ textAlign: 'left', marginLeft: '5mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                    UBND THÀNH PHỐ ĐÀ NẴNG
                    <br />
                    <div style={{ display: "block", textAlign: "left", marginLeft: '2mm', fontWeight: "bold", fontFamily: 'Times New Roman' }}>
                        QUỸ ĐẦU TƯ PHÁT TRIỂN
                        <hr style={{ borderTop: "1px solid", width: "50%", marginLeft: '8mm', marginTop: "1px", marginBottom: "2px" }} />
                    </div>
                </Col>
                <Col span={15} className="right-col" style={{ textAlign: 'right', marginRight: '12mm',  fontFamily: 'Times New Roman' }}>
                    <span style={{ fontWeight: 'bold', fontFamily: 'Times New Roman' } } >CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</span>
                    <br />
                    <div style={{ display: "block", textAlign: "right", marginRight: '15mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        Độc lập - Tự do - Hạnh phúc
                        <hr style={{ borderTop: "1px solid", marginTop: "1px", marginLeft: '112mm', width: "20%" }} />
                    </div>
                    <div style={{ display: "block", marginTop: "2mm", textAlign: "right", marginRight: '8mm', fontFamily: 'Times New Roman', fontStyle: 'italic' }}>
                        Đà nẵng,ngày {ngaytoday} tháng {thangtoday} năm {namtoday}
                        </div>
                </Col>
            </Row>
            <Row justify="center">
                <Col
                    span={24}
                    style={{ textAlign: "center", marginTop: "5mm", fontWeight: "bold", fontSize: "25px", fontFamily: 'Times New Roman' }}
                >
                    BẢNG TỔNG HỢP
                </Col>
            </Row>
            <Row justify="center">
                <Col
                    span={24}
                    style={{ textAlign: "center", marginTop: "5mm", fontSize: "18px", fontFamily: 'Times New Roman', fontWeight: 'bold' }}
                >
                    Xếp loại mức độ hoàn thành công việc (A, B, C) tháng {thang} năm {nam}
                    <br />
                    <div style={{ display: "block", textAlign: "center",fontFamily: 'Times New Roman' }}>
                        của CBVC Quỹ Đầu tư phát triển thành phố Đà Nẵng
                    </div>
                </Col>
            </Row>
            <Row justify="center">
                <Col
                    span={24}
                    style={{ textAlign: "left", marginTop: "5mm", fontSize: "18px", fontFamily: 'Times New Roman', textIndent: '4ch' }}
                >
                    Trên cơ sở kết quả xếp loại mức độ hoàn thành công việc (A, B, C) tháng {thang} năm {nam}  của các phòng, ban nghiệp vụ và ý kiến nhận xét của Phó Giám đốc Phụ trách; Văn phòng tổng hợp kết quả như sau:
                </Col>
            </Row>
            <Row className="form-group" gutter={8}>
                <Col span={5} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                    1.Xếp loại ABC
                </Col>
            </Row>
            <Row>
                <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                    <div className="  table-content" >
                        <table style={{ width: "100%", borderCollapse: "collapse", borderColor: 'black' }} >
                            <colgroup></colgroup>
                            <thead className="  table-thead">
                                <tr style={{ fontFamily: 'Times New Roman'}} >
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "26px", verticalAlign: "bottom", borderCollapse: "collapse", borderLeft: "1px solid   ", borderRight: "1px solid   ", borderTop: "1px solid   " }}>
                                        STT
                                    </th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "62px",  verticalAlign: "bottom", borderCollapse: "collapse", borderRight: "1px solid   ", borderTop: "1px solid   " }}>Họ và tên</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "50px",  verticalAlign: "bottom", borderTop: "1px solid   " }}>Chức vụ</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" colSpan={2} style={{ textAlign: "center", width: "60px", borderCollapse: "collapse", border: "1px solid   " }}>Cá nhân tự xếp loại</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" colSpan={2} style={{ textAlign: "center", width: "60px", borderCollapse: "collapse", border: "1px solid   " }}>Xếp loại của trưởng phòng, ban nghiệp vụ</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" colSpan={2} style={{ textAlign: "center", width: "60px", borderCollapse: "collapse", border: "1px solid   " }}>Ý kiến của Phó Giám đốc phụ trách</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "50px", verticalAlign: "bottom", borderCollapse: "collapse", borderRight: "1px solid   ", borderTop: "1px solid   " }}>Phê duyệt của</th>
                                </tr>
                            </thead>
                            <thead className="  table-thead">
                                <tr style={{ fontFamily: 'Times New Roman' }}>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "26px", borderCollapse: "collapse", borderRight: "1px solid   ", borderLeft: "1px solid   " }}></th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "62px", borderCollapse: "collapse", borderRight: "1px solid   " }}></th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "50px"}}></th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={rowTableFormat}>Tổng điểm</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={rowTableFormat}>Xếp loại</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={rowTableFormat}>Tổng điểm</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={rowTableFormat}>Xếp loại</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={rowTableFormat}>Tổng điểm</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={rowTableFormat}>Xếp loại</th>
                                    <th className="  table-cell" rowSpan={2} scope="col" style={{ textAlign: "center", width: "26px", borderCollapse: "collapse", borderRight: "1px solid   ", borderLeft: "1px solid   " } }> Giám đốc</th>
                                </tr>
                            </thead>
                            <tbody className="  table-tbody">
                                {Object.keys(groupedData).map((tenDonVi, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="  table-row   table-row-level-0">
                                            <td className="  table-cell" colSpan={10} style={{ paddingLeft: "15px",height: "30px", tableLayout: "auto", borderCollapse: "collapse", border: "1px solid   ", fontWeight: "bold", fontFamily: 'Times New Roman' }}>
                                                {tenDonVi}
                                            </td>
                                        </tr>
                                        {groupedData[tenDonVi].map((groupItem, groupIndex) => (
                                            <tr
                                                className="  table-row   table-row-level-0"
                                                key={`${index}-${groupIndex}`}
                                                style={{ height: "50px", textAlign: "center", tableLayout: "auto", borderCollapse: "collapse", border: "1px solid   ", fontFamily: 'Times New Roman' }}
                                            >
                                                <td className="  table-cell">
                                                    <span style={{ height: "50px", textAlign: "center", fontFamily: 'Times New Roman' }}>{groupIndex + 1}</span>
                                                </td>
                                                <td className="  table-cell" style={rowFormat}>{groupItem.hoTen}</td>
                                                <td className="  table-cell" style={rowFormat}>{groupItem.tenChucVu}</td>
                                                <td className="  table-cell" style={rowFormat}>{groupItem.tuDanhGia}</td>
                                                <td className="  table-cell" style={rowFormat}>
                                                    {groupItem.tuDanhGia !== null && groupItem.tuDanhGia !== undefined ? (
                                                        <span style={{ fontFamily: 'Times New Roman' }}>
                                                            {layXepLoai(groupItem.tuDanhGia)}
                                                        </span>
                                                    ) : null}
                                                </td>

                                                <td className="  table-cell" style={rowFormat}>
                                                    {groupItem.truongPhong}
                                                </td>
                                                <td className="  table-cell" style={rowFormat}>
                                                    {groupItem.truongPhong !== null && groupItem.truongPhong !== undefined ? (
                                                        <span style={{ fontFamily: 'Times New Roman' }}>
                                                            {layXepLoai(groupItem.truongPhong)}
                                                        </span>
                                                    ) : null}
                                                </td>

                                                <td className="  table-cell" style={rowFormat}>
                                                    {groupItem.lanhDao}
                                                </td>
                                                <td className="  table-cell" style={rowFormat}>
                                                    {groupItem.tuDanhGia !== null && groupItem.tuDanhGia !== undefined ? (
                                                        <span style={{ fontFamily: 'Times New Roman' }}>
                                                            {layXepLoai(groupItem.lanhDao)}
                                                        </span>
                                                    ) : null}
                                                </td>
                                                <td className="  table-cell" key={groupItem.xepLoai} style={rowFormat}>
                                                    {groupItem.xepLoai}
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Row>
            <Col span={8} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                2. Về chấp hành nội quy, quy chế cơ quan:
            </Col>
            <Col span={24} className="left-col" style={{ textAlign: 'left', marginLeft: '5mm', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                {noiDung}
            </Col>
            <Row justify="center">
                <Col span={6} className="left-col" style={{ textAlign: 'left', marginLeft: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman, Times, serif' }}>
                    NGƯỜI LẬP
                    <br />
                    <strong style={{ display: "block", textAlign: "left", marginLeft: '0mm', fontWeight: "bold", paddingTop: '100px', fontFamily: 'Times New Roman, Times, serif' }}>
                        {user.hoTen}
                    </strong>
                </Col>
                <Col span={8} className="left-col" style={{ textAlign: 'center', margin: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman, Times, serif' }}>
                    CHÁNH VĂN PHÒNG
                    <br />
                    <strong style={{ display: "block", textAlign: "center", marginLeft: '1mm', fontWeight: "bold", paddingTop: '100px' }}>
                        {chanhVP && chanhVP.hoTen}
                    </strong>
                </Col>
                <Col span={4} className="left-col" style={{ textAlign: 'center', marginLeft: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman, Times, serif' }}>
                    GIÁM ĐỐC QUỸ
                    <br />
                    <strong style={{ display: "block", textAlign: "center", marginLeft: '1mm', fontWeight: "bold", paddingTop: '100px'}}>
                        {giamDoc && giamDoc.hoTen}
                    </strong>
                </Col>
            </Row>
            <div style={{ paddingTop: "80px", paddingBottom: "80px" }}>
                <hr style={{ borderTop: "1px solid", marginTop: "0px", marginBottom: "4px" }} />
                <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(Bản in chuyển đổi từ Phần mềm quản lý nhân sự tiền lương của Quỹ Đầu tư phát triển thành phố Đà Nẵng)</div>
                <Row gutter={8} className="text-center" style={{ paddingTop: "10px" }}>
                    <Col span={12} >
                    </Col>
                    <Col span={12}  >
                        <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>Ngày {ngaytoday}/{thangtoday}/{namtoday}</div>
                        <label style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>NGƯỜI CHUYỂN ĐỔI</label>
                        <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>(Ký và ghi rõ họ tên)</div>
                    </Col>
                </Row>
            </div>
        </PrintPageToHere>
    );
};

export default InBaoCaoKPIPhongBan;
